import { render, staticRenderFns } from "./index.vue?vue&type=template&id=616ae160&"
import script from "./index.vue?vue&type=script&lang=ts&setup=true&"
export * from "./index.vue?vue&type=script&lang=ts&setup=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('616ae160')) {
      api.createRecord('616ae160', component.options)
    } else {
      api.reload('616ae160', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=616ae160&", function () {
      api.rerender('616ae160', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/[town_translit]/vrach/[doctor_translit]/index.vue"
export default component.exports